<template>
  <span v-show="loading" class="loader-circle-animated"></span>

  <img
    v-show="!loading"
    :id="id"
    :src="src"
    :alt="alt"
    :style="style"
    loading="lazy"
  />
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      default: '',
    },

    src: {
      type: String,
      default: '',
    },

    alt: {
      type: String,
      default: '',
    },

    style: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      loading: false,
      attempts: 1,
    };
  },

  mounted() {
    this.loadImage();
  },

  created() {
    //
  },

  methods: {
    loadImage() {
      const img = document.querySelector(`#${this.id}`)

      if (img) {
        img.addEventListener('load', () => {
          setTimeout(() => {
            this.loading = false;
          }, 500);
        });

        img.addEventListener('error', event => {
          if ((!img.complete || !img.complete) && this.attempts < 2) {
            this.loadImage();
          } else {

          }

          setTimeout(() => {
            this.loading = false;
          }, 500);
          console.log('error', event)
        });
      }
    },
  },
};
</script>

<style scoped>
.typing {
  position: relative;
  min-height: 8px;
}

.text-typing {
  color: #808080 !important;
  font-size: 12px;
  margin: 0;
  padding: 0;
}

span {
  content: '';
  animation: blink 1.5s infinite;
  animation-fill-mode: both;
  height: 6px;
  width: 6px;
  background: #424242;
  position: absolute;
  left: 0;
  top: 0;
  border-radius: 50%;
}

span:nth-child(2) {
  animation-delay: .2s;
  margin-left: 10px;
}

span:nth-child(3) {
  animation-delay: .4s;
  margin-left: 20px;
}


@keyframes blink {
  0% {
    opacity: .1;
  }
  20% {
    opacity: 1;
  }
  100% {
    opacity: .1;
  }
}

</style>
